import React from 'react';
const facts = [{
  value: '16',
  label: 'Tygodni zaplanowanych'
}, {
  value: '50',
  label: 'Gotowych ćwiczeń'
}, {
  value: '3',
  label: 'Ścieżki poziomów'
}, {
  value: '5',
  label: 'Darmowych bonusów'
}];
export function SocialProofBar() {
  return <section aria-label="Co zawiera pakiet" className="border-y border-night-600 bg-night-900" data-id="element-399" data-mp="29sctw80qu2mp">
      <div className="mx-auto grid max-w-shell grid-cols-2 gap-y-7 px-5 py-8 sm:px-6 sm:py-10 lg:grid-cols-4 lg:gap-x-8" data-id="element-400" data-mp="25qr8fya58g0w">
        {facts.map((fact, index) => <div key={fact.label} className={`px-1 lg:px-6 ${index > 0 ? 'lg:border-l lg:border-night-600' : ''}`} data-id="element-401" data-mp="2xl34odwwufve" data-mpi={index}>
            <p className="font-display text-4xl leading-none text-amber sm:text-5xl" data-id="element-402" data-mp="2tk9h5lndr331">{fact.value}</p>
            <p className="mt-3 max-w-[15rem] text-xs font-semibold uppercase tracking-label leading-relaxed text-cream-muted" data-id="element-403" data-mp="2olob35lg5p6o">
              {fact.label}
            </p>
          </div>)}
      </div>
    </section>;
}